const nationals_themes = {
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.8)',
      banner_text: '#ffffff',
      banner_section: '#ffffff',
      banner_subtitle: 'rgba(255, 255, 255, 0.9)',
      banner_mins: 'rgba(255, 255, 255, 0.9)',
      grid_section: '#ffffff',
      grid_subtitle: 'rgba(255, 255, 255, 1.0)',
      grid_mins: 'rgba(255, 255, 255, 0.9)',
    },
    
    logo: {
      boxShadow: 'none',
      borderRadius: '0',
      background: 'transparent',
      padding: '0',
    },

    background: {
      primary: 'linear-gradient(135deg, #14225A 0%, #0d1740 100%)',
      banner: 'linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.04) 100%)',
      banner_here: '#AB0003',
      grid: 'linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.04) 100%)',
    }
  };

export default nationals_themes;